const pushPermissionID=(userPermissions,ID,LIST,row)=>{
  userPermissions?.map((user) => {
    return user?.function === row?.function
      ? ID.push(user._id) && LIST?.push(user?.method)
      : null;
  })
}
export default pushPermissionID;